export default {
    url: '/evaluation',
    template: `
        <div class="col00">
            <ui-view></ui-view>
        </div>
    `,
    data: {
        canAccess: (AuthService, PrivilegeService) => {
            return PrivilegeService.canManage360();
        }
    },
    abstract: true,
    controller ($state) {
        this.$state = $state;
    }
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/evaluation/index.js